export function createProjectFilesHref({
  projectId,
  scopeId,
  scopeType,
}: {
  projectId: string;
  scopeId?: string;
  scopeType?: string;
}) {
  const params = new URLSearchParams();

  if (scopeId) params.set("scopeId", scopeId);
  if (scopeType) params.set("scopeType", scopeType);

  const search = params.toString();

  return search ? `/files/projects/${projectId}?${search}` : `/files/projects/${projectId}`;
}
